var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgFundamentals(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C12.5523 0 13 0.447715 13 1V2H21C21.5523 2 22 2.44772 22 3V18H23C23.5523 18 24 18.4477 24 19C24 19.5523 23.5523 20 23 20H16.4142L18.7071 22.2929C19.0976 22.6834 19.0976 23.3166 18.7071 23.7071C18.3166 24.0976 17.6834 24.0976 17.2929 23.7071L13.5858 20H13V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V20H10.4142L6.70711 23.7071C6.31658 24.0976 5.68342 24.0976 5.29289 23.7071C4.90237 23.3166 4.90237 22.6834 5.29289 22.2929L7.58579 20H1C0.447715 20 0 19.5523 0 19C0 18.4477 0.447715 18 1 18H2V3C2 2.44772 2.44772 2 3 2H11V1C11 0.447715 11.4477 0 12 0ZM4 4V18H20V4H4ZM11 8.17071C9.83481 8.58254 9 9.69378 9 11C9 12.6569 10.3431 14 12 14C13.3062 14 14.4175 13.1652 14.8293 12H12C11.4477 12 11 11.5523 11 11V8.17071ZM13 8.17071V10H14.8293C14.528 9.14759 13.8524 8.47199 13 8.17071ZM7 11C7 8.23857 9.23858 6 12 6C14.7614 6 17 8.23857 17 11C17 13.7614 14.7614 16 12 16C9.23858 16 7 13.7614 7 11Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundamentals);
export default __webpack_public_path__ + "static/media/fundamentals.caad2706.svg";
export { ForwardRef as ReactComponent };